import React, { useEffect, useRef, useState } from 'react';
import { TFunction } from 'react-i18next';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  Icon,
  IconColor,
  IconName,
  Tooltip,
  withTranslation,
} from '@piwikpro/ui-components';
import styles from './CopyIcon.module.css';

const COPIED_RESET_DELAY = 2000;

interface CopyIconProps {
  value: string
  t: TFunction
}

export const CopyIcon = ({ value, t }: CopyIconProps) => {
  const [copied, setCopied] = useState(false);
  const resetTimeout = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => () => {
    if (resetTimeout.current) {
      clearTimeout(resetTimeout.current);
    }
  }, []);

  const icon: {
    name: IconName
    color: IconColor
  } = copied ? {
    name: 'checkmark-circle',
    color: 'green',
  } : {
    name: 'duplicate',
    color: 'gray',
  };

  const handleCopy = () => {
    if (copied) {
      return;
    }

    setCopied(true);
    resetTimeout.current = setTimeout(() => {
      setCopied(false);
    }, COPIED_RESET_DELAY);
  };

  return (
    <div className={styles['copy-icon']}>
      <Tooltip
        content={copied ? t('copied') : t('copy')}
        preventHideOnMouseDown
      >
        <div>
          <CopyToClipboard text={value}>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
            <div
              role="button"
              tabIndex={0}
              onClick={handleCopy}
            >
              <Icon name={icon.name} color={icon.color} />
            </div>
          </CopyToClipboard>
        </div>
      </Tooltip>
    </div>
  );
};

export default withTranslation('components')(CopyIcon);
